import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './FlashMessage.css';


class FlashMessage extends Component {
  static get propTypes() {
    return {
      className: PropTypes.string,
      alertType: PropTypes.string.isRequired
    };
  }

  render() {
    const classes = classNames('FlashMessage', this.props.className);

    const alertType = classNames('alert', `alert-${this.props.alertType}`, 'text-center');

    return (
      <div className={classes}>
        <div className="card">

          <div className={alertType} role="alert">

            { this.props.children }

          </div>

        </div>
      </div>
    );
  }
}


export default FlashMessage;



// WEBPACK FOOTER //
// ./src/components/alerts/FlashMessage/FlashMessage.js